import type { ILink } from "@contentful-api/types/contentful";
import { getAssetFileUrl } from "@contentful-api/helpers/getAssetFileUrl";
import { isAllowedExternalUrl } from "@contentful-api/helpers/isAllowedExternalUrl";

type LinkHrefFields = Pick<ILink["fields"], "externalUrl" | "linkAsset">;

export const resolveLinkExternalHref = (fields: LinkHrefFields) => {
    if (fields.externalUrl && isAllowedExternalUrl(fields.externalUrl)) {
        return { href: fields.externalUrl, isAsset: false };
    }

    const href = getAssetFileUrl(fields.linkAsset);
    return href ? { href, isAsset: true } : undefined;
};
